'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';

export function ActiveCampaignLeadCapture({ scriptSrc }: { scriptSrc: string }): React.ReactNode {
  const pathname = usePathname() ?? '';
  const isHomepage = pathname === '/';
  return isHomepage ? <Script src={scriptSrc} charSet="utf-8" /> : null;
}
